<template>
  <svg viewBox="0 0 752 480" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="linear-gradient" x1="298" x2="738" y1="299.98" y2="299.98" gradientUnits="userSpaceOnUse">
      <stop stop-color="#a1b003" offset="0"/>
      <stop stop-color="#bac803" offset="1"/>
    </linearGradient>
  </defs>
  <path fill="#b0fff7" d="M298 17h440v321.45H298z"/>
  <g id="item-anim3">
    <path class="cls-2" fill="#1a1e1c" d="M435.54 152.65h1.301V279.8h-1.301z"/>
    <path class="cls-3" fill="#3c4744" d="M434.16 180.21h4.31v1.91h-4.31zM434.16 183.08h4.31v1.91h-4.31z"/>
  </g>
  <circle class="cls-4" cx="436.31" cy="254.85" r="2.87" fill="#83b0ba"/>
  <path class="cls-3" fill="#3c4744" d="M434.88 259.63h2.87v31.58h-2.87z"/>
  <path class="cls-2" fill="#1a1e1c" d="M432.48 258.2h7.66v1.91h-7.66zM429.38 287.86h13.87v5.26h-13.87z"/>
  <path class="cls-3" fill="#3c4744" d="M423.21 271.64h25.29v2.53h-25.29z"/>
  <ellipse class="cls-4" cx="448.93" cy="272.9" rx="1.91" ry="3.35" fill="#83b0ba"/>
  <circle class="cls-4" cx="436.31" cy="272.9" r="5.02" fill="#83b0ba"/>
  <path fill="#25352d" d="M538.88 215.62h72.24l18.18 63.15h-90.42z"/>
  <g id="item-anim4">
    <path d="M465.3 122.65l-2.8-.94 7.5-17.78 7.49 3.74-.94-41.18c-55.22 43.06-42.11 103-42.11 103l38.37-45.86-6.55-2.81zm-8.42-28.08l10.29-12.17 6.56 2.81v11.23l-10.3 2.81-6.55-2.81zm-15 61l-3.72-1.12a67.18 67.18 0 0 1 3.74-33.69l4.68-1.87 6.56 2.8 4.68 14zM455.94 118l-8.42-3.74-1.87-2.81 4.68-9.36 3.74-1.87 7.49 2.81z" fill="#68a6ad"/>
    <path d="M434.42 170.16a.47.47 0 0 1-.17 0 .69.69 0 0 1-.52-.53c0-.15-3.27-15.35.34-35.61 3.33-18.69 13.33-45.68 42-68.05a.7.7 0 0 1 1.14.54l.94 41.18a.71.71 0 0 1-.33.61.73.73 0 0 1-.7 0l-6.81-3.41-6.9 16.38 1.5.51.67-1.33a.71.71 0 0 1 .91-.33l6.55 2.81a.69.69 0 0 1 .41.48.7.7 0 0 1-.15.62L435 169.9a.74.74 0 0 1-.58.26zm41.44-102.23c-27.47 21.9-37.13 48.06-40.39 66.25a103.86 103.86 0 0 0-.63 33.66l36.8-44-5.07-2.17-.63 1.28a.72.72 0 0 1-.86.35l-2.81-.94a.67.67 0 0 1-.42-.37.75.75 0 0 1 0-.57l7.49-17.78a.72.72 0 0 1 .41-.39.69.69 0 0 1 .56 0l6.44 3.22zm-34 88.37a.64.64 0 0 1-.2 0l-3.66-1.15a.7.7 0 0 1-.5-.57 68.55 68.55 0 0 1 3.8-34.08.68.68 0 0 1 .38-.38l4.68-1.87a.68.68 0 0 1 .54 0l6.55 2.8a.74.74 0 0 1 .4.43l4.68 14a.73.73 0 0 1-.12.67L442.43 156a.72.72 0 0 1-.55.3zm-3.09-2.37l2.84.85L457 135.61l-4.45-13.37-6-2.57-4.13 1.65a67.61 67.61 0 0 0-3.63 32.61zm17.15-35.25a.71.71 0 0 1-.28-.06l-8.43-3.75a.72.72 0 0 1-.3-.25l-1.87-2.81a.7.7 0 0 1 0-.71l4.68-9.36a.67.67 0 0 1 .31-.31l3.74-1.88a.75.75 0 0 1 .57 0l7.49 2.8a.71.71 0 0 1 .41.91l-5.61 15a.7.7 0 0 1-.39.4.67.67 0 0 1-.3.02zm-7.95-5l7.55 3.36 5.11-13.61-6.52-2.43-3.26 1.63-4.39 8.78zM463.43 100a.71.71 0 0 1-.28-.06l-6.55-2.81a.7.7 0 0 1-.43-.65v-1.91a.71.71 0 0 1 .17-.46L466.63 82a.72.72 0 0 1 .82-.2l6.55 2.76a.7.7 0 0 1 .42.65v11.23a.72.72 0 0 1-.52.69l-10.29 2.8a.63.63 0 0 1-.18.07zm-5.84-4l5.89 2.52L473 95.9V85.68l-5.64-2.42-9.79 11.57z" fill="#446466"/>
    <path fill="#3c5c68" stroke="#74a6b5" stroke-miterlimit="10" stroke-width="3" d="M471.27 107.21l140.88 53.2.1 13.72-145.61-54.66z"/>
  </g>
  <path d="M561.36 247.17H518.3a1.42 1.42 0 0 1 0-2.83h37.42L519.55 225a1.42 1.42 0 0 1-.71-1.55l1.43-6.69a1.41 1.41 0 0 1 .68-.93l30.68-17.67-1.57-7-23-15.48a1.4 1.4 0 0 1-.61-1.34l.48-3.83a1.41 1.41 0 0 1 1.4-1.24H548a1.42 1.42 0 0 1 0 2.83h-18.4l-.22 1.72 22.73 15.31a1.41 1.41 0 0 1 .59.86l1.91 8.62a1.41 1.41 0 0 1-.67 1.53l-31 17.86-1.08 5 40.2 21.5a1.41 1.41 0 0 1-.67 2.66z" fill="#558689"/>
  <path class="cls-10" d="M550.84 197.42H525a1.42 1.42 0 0 1 0-2.83h25.84a1.42 1.42 0 0 1 0 2.83zM555.62 221.34h-34a1.42 1.42 0 0 1 0-2.83h34a1.42 1.42 0 1 1 0 2.83z" fill="#315e5e"/>
  <path fill="#63959e" d="M567.32 261.17h-4.68l-19.65-102.95h-11.23l-14.98 102.95h-6.55l4.68-12.17 14.97-98.27h15.91z"/>
  <g fill="#1a1e1c">
    <path class="cls-2" d="M507.3 267.77h7.66v25.36h-7.66zM555.62 267.77h7.66v25.36h-7.66zM599.64 267.77h14.35v25.36h-14.35z"/>
  </g>
  <path class="cls-3" fill="#3c4744" d="M617.82 211.31l12.44 8.61 17.22 2.87v18.66h-68.89l1.43-21.05z"/>
  <circle class="cls-12" cx="537.6" cy="147.92" r="4.68" fill="#48787a"/>
  <g id="item-anim1">
    <path class="cls-13" d="M582.89 257.72s12.92-8.13 42.59-3.83c0 0 9.09-.95 4.78 7.18 0 0-7.66 10.05-25.36 12 0 0-18.66 1.91-26.79-7.18 0-.04-5.26-7.21 4.78-8.17z" fill="#627770"/>
    <path class="cls-14" d="M607.89 225.82a7.42 7.42 0 0 0-14.78 1.28v.23l4.17 48.14 14.77-1.28-4.16-48.14z" fill="#8c9995"/>
    <circle cx="602.41" cy="253.05" r="5.5" fill="#45544f"/>
    <circle cx="602.41" cy="253.05" r="1.91" fill="#202825"/>
  </g>
  <circle class="cls-12" cx="537.96" cy="147.92" r="4.68" fill="#48787a"/>
  <circle class="cls-4" cx="537.96" cy="147.92" r="2.56" fill="#83b0ba"/>
  <path class="cls-3" fill="#3c4744" d="M504.91 260.11h65.31v9.57h-65.31z"/>
  <path class="cls-2" fill="#1a1e1c" d="M634.09 222.32h16.75v70.81h-16.75z"/>
  <g id="item-anim2">
    <path class="cls-2" fill="#1a1e1c" d="M601.7 182.6h1.44v69.85h-1.44z"/>
    <path class="cls-13" fill="#627770" d="M599.78 164.9h5.26v12.44h-5.26z"/>
    <path class="cls-14" fill="#8c9995" d="M597.87 175.91h9.09l-1.44 10.52h-6.22z"/>
  </g>
  <path class="cls-17" fill="#634024" d="M298 331.96h440V358H298zM298 380.96h440V426H298z"/>
  <path fill="#4c2215" d="M298 424.41h440v45.04H298z"/>
  <path fill="#a87735" d="M298 305.96h440V332H298z"/>
  <path fill="url(#linear-gradient)" d="M298 292.96h440V307H298z"/>
  <path fill="#ffbd48" d="M298 357.75h440V381H298z"/>
  <path fill="#5b5b5b" d="M423.83 411h25v58.45h-25z"/>
  <path fill="#494949" d="M423.83 293v97h-6.5v25h38v-25h-6.5v-97z"/>
  <g fill="none" stroke="#231410" stroke-miterlimit="10" stroke-width="4">
    <path class="cls-24" d="M424 293v97h-15M448 293v97h15M424 469.45V414h-15M448 469.45V414h15"/>
  </g>
  <g fill="#231410">
    <path id="item-arrow3" class="cls-25 arrow" d="M436 339l-5 16h10.5z"/>
    <path id="item-arrow2" class="cls-25 arrow" d="M464 402.25l16 5v-10.5z"/>
    <path id="item-arrow1" class="cls-25 arrow" d="M368 402.25l-16 5v-10.5z"/>
  </g>
  <text id="texto2" x="520" y="412.76" fill="#fff" font-family="MyriadPro-BoldCond,Myriad Pro" font-size="30" font-weight="700">
    <tspan letter-spacing="0">Roca reservorio</tspan>
  </text>
  <g id="item1" v-if="!showButtons">
    <path class="cls-25" fill="#231410" d="M354 205.72l23 7.18v-15.09z"/>
    <path class="cls-24" fill="none" stroke="#231410" stroke-miterlimit="10" stroke-width="4" d="M406 399h-13V205h-20"/>
  </g>
  <g id="texto1" v-if="!showButtons">
    <path class="cls-32" fill="#fff" stroke="#beeb7b" stroke-miterlimit="10" stroke-width="3" d="M26.75 176h321v57h-321z"/>
    <text x="44.42" y="214.76" font-family="MyriadPro-Cond,Myriad Pro" font-size="30">
      I<tspan x="50.39" y="214.76" letter-spacing="-.01em">n</tspan><tspan x="62.36" y="214.76" letter-spacing="-.01em">t</tspan><tspan x="69.77" y="214.76">e</tspan><tspan x="80.66" y="214.76" letter-spacing=".03em">r</tspan><tspan x="88.88" y="214.76" letter-spacing="-.01em">v</tspan><tspan x="99.02" y="214.76">alos</tspan><tspan x="140.54" y="214.76" letter-spacing="0">c</tspan><tspan x="149.69" y="214.76">añoneados abie</tspan><tspan x="294.34" y="214.76" letter-spacing=".02em">r</tspan><tspan x="302.5" y="214.76" letter-spacing="-.01em">t</tspan><tspan x="309.91" y="214.76">os</tspan>
    </text>
  </g>
  <g id="boton1" v-if="showButtons" class="fix-svg-origin animated fadeIn hvr hvr-scale" @click="$emit('mostrarTexto',1)">
    <path class="cls-32" fill="#fff" stroke="#beeb7b" stroke-miterlimit="10" stroke-width="3" d="M245.5 302.5h124v67h-124z"/>
    <text class="cls-41" x="263.81" y="331.66" font-family="MyriadPro-Cond, 'Myriad Pro'" font-size="26">
      <tspan class="cls-42" letter-spacing=".01em">O</tspan> <tspan x="275.56" y="331.66">il and gas</tspan> <tspan x="259.96" y="354.66">behind pipe</tspan>
    </text>
  </g>
  <g id="boton2" v-if="showButtons" class="fix-svg-origin animated fadeIn hvr hvr-scale" @click="$emit('mostrarTexto',2)">
    <path class="cls-32" fill="#fff" stroke="#beeb7b" stroke-miterlimit="10" stroke-width="3" d="M480.5 302.5h124v67h-124z"/>
    <text class="cls-41" x="498.81" y="331.66" font-family="MyriadPro-Cond, 'Myriad Pro'" font-size="26">
      <tspan class="cls-42" letter-spacing=".01em">O</tspan> <tspan x="510.56" y="331.66">il and gas</tspan> <tspan x="494.96" y="354.66">behind pipe</tspan>
    </text>
  </g>
</svg>
</template>
<script>
export default {
  props:  {
    showButtons: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
  #item-anim1, #item-anim2 {
    transition: all 500ms;
  }
  @keyframes anim1 {
    from{ transform: rotate(0)}
    to{ transform: rotate(359deg)}
  }
  #item-anim3 {
    transform-box: fill-box;
    transform-origin: center;
    /* transform: rotate(270deg); */
    animation: anim4;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes anim2 {
    /* Se podrían calcular los angulos y posiciones matemáticamente pero esta aproximación no esta tan mal */
    0%{ transform: translate(0, 0)}
    12%{ transform: rotate(15deg) translate(-20px, -5px)}
    25%{ transform: rotate(20deg) translate(-30px, -15px)}
    37%{ transform: rotate(15deg) translate(-25px, -30px)}
    50%{ transform: rotate(0) translate(0, -50px)}
    62%{ transform: rotate(-15deg) translate(25px, -30px)}
    75%{ transform: rotate(-20deg) translate(30px, -15px)} 
  }
  #item-anim4 {
    transform-origin: 537px 147px;
    animation: anim3;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes anim3 {
    0%{ transform: rotate(0)}
    50%{ transform: rotate(-40deg)}
  }
  #item-anim1 {
    transform-origin: 602px 230px;
    animation: anim1;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  #item-anim2 {
    transform-origin: 602px 253px;
    animation: anim2;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes anim4 {
    0%{ transform: translateY(-30px)}
    50%{ transform: translateY(10px)}
    100%{ transform: translateY(-30px)}
  }

.arrow {
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
  #item-arrow1{
    animation-name: arrowLeft;
  }
  #item-arrow2{
    animation-name: arrowRight;
  }
  #item-arrow3{
    animation-name: arrowUp;
  }

  @keyframes arrowLeft {
    from {transform: translateX(0)}
    to {transform: translateX(50px)}
  }
  @keyframes arrowRight {
    from {transform: translateX(0)}
    to {transform: translateX(-20px)}
  }
  @keyframes arrowUp {
    from {transform: translateY(25px)}
    to {transform: translateY(-25px)}
  }
  .cls-2{fill:#1a1e1c}.cls-3{fill:#3c4744}.cls-4{fill:#83b0ba}.cls-24,.cls-32{stroke-miterlimit:10}.cls-32{stroke-width:3px}.cls-10{fill:#315e5e}.cls-12{fill:#48787a}.cls-13{fill:#627770}.cls-14{fill:#8c9995}.cls-17{fill:#634024}.cls-24{fill:none;stroke:#231410;stroke-width:4px}.cls-25{fill:#231410}.cls-32{fill:#fff;stroke:#beeb7b}.cls-41{font-family:MyriadPro-Cond,Myriad Pro;font-size:26px}.cls-42{letter-spacing:.01em}
</style>